const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'avif', 'heic', 'tiff'];
const EXTENSION_ICONS = {
    pdf: 'documents',
    doc: 'documents',
    docx: 'documents',
    odt: 'documents',
    rtf: 'documents',
    txt: 'documents',
    csv: 'documents',
    xls: 'documents',
    xlsx: 'documents',
    ppt: 'documents',
    pptx: 'documents',
    json: 'code',
    xml: 'code',
    yml: 'code',
    yaml: 'code',
    zip: 'storage',
    rar: 'storage',
    '7z': 'storage',
    tar: 'storage',
    gz: 'storage',
};
export const getFileMeta = (filename, contentType) => {
    const lastDot = filename ? filename.lastIndexOf('.') : -1;
    const rawExt = lastDot > 0 ? filename.slice(lastDot + 1).toLowerCase() : '';
    const extension = rawExt.toUpperCase();
    const isImage = (!!contentType && contentType.toLowerCase().startsWith('image/')) ||
        IMAGE_EXTENSIONS.includes(rawExt);
    const iconName = EXTENSION_ICONS[rawExt] || 'file';
    return { isImage, extension, iconName };
};
